import { DataBean } from "../DataBean";

export class ApplyForClose extends DataBean {



    public async applyToProductionOrderForClose(idProductionOrder: any, productionOrderDate: any, apply: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_applyToProductionOrderForClose_Number_java.util.Date_Boolean", [idProductionOrder, productionOrderDate, apply]);
    }

}